<template>
  <div>
    <el-dialog title="Download" :width="dialogWidth" :visible="visible" :close-on-click-modal="false" @close="visible = false">
      <div style="display: flex;flex-direction: column;align-items: center;color: #262626;">
        <i class="el-icon-document-checked" style="color: #3EA19D;font-size: 70px;"></i>
        <h1 style="font-size: 30px;font-weight: normal;line-height: 1;margin:10px 0 20px 0;">Your file is ready!</h1>
        <p style="color: #717D96;">Do you really want to delete this records?</p>
        <p style="color: #717D96;">This process cannot be undone.</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" size="small" @click="visible = false">Cancel</el-button>
        <el-button type="primary" size="small" @click="downloadImage" style="background-color:#3EA19D;border-color: #3EA19D;">Download</el-button>
      </span>
    </el-dialog>
    <div ref="imgUrl" style="font-size: 0;position: absolute;left:-2000px;">
      <div style="font-size: 0;background-size: cover;background-position: center;" :style="'background-image:url('+(info.statusNew == 'S3' ? getImgS3(info.newImage) : getImg(info.newImage))+');'">
        <canvas ref="canvas" width="500" height="300" style="background-color: transparent;"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment/moment';
import { postAction,getAction } from '@/network/manage';
import html2canvas from 'html2canvas'
export default {
  name: 'Download',
  components: {},
  data() {
    return {
      dialogWidth:'500px',
      visible:false,
      id: '',
      info:'',
      form_loading: false,
    }
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.setDialogWidth()
      })()
    }
  },
  computed: {

  },
  created() {
    this.setDialogWidth()
  },
  methods: {
    getImgS3(key) {
      return process.env.VUE_APP_BASE_XA + '/sys/common/test/getImgS3?key=' + key
    },
    getImg(path) {
      return process.env.VUE_APP_BASE_XA + '/sys/common/test/view/' + path
    },
    init(id) {
      this.visible = true
      this.info = ''
      this.form_loading = true
      const that = this
      getAction('/admin/caseHistory/queryById?id='+id).then((res) => {
        if(res.success){
          this.info = res.result
          for(let i = 0; i < this.info.results.length; i++){
            if(this.info.results[i].id == this.info.newImageId){
              this.$set(this.info,'newImageMask',this.info.results[i].imageMask);
            }
          }
          if(this.info.teethWhitening == 1){
            const canvas = this.$refs.canvas;
            const ctx = canvas.getContext('2d');
            const imageMask = new Image();
            imageMask.crossOrigin = "anonymous";
            imageMask.src = (this.info.statusNew == 'S3' ? this.getImgS3(this.info.newImageMask) : this.getImg(this.info.newImageMask))
            imageMask.onload = () => {
              canvas.width = imageMask.width
              canvas.height = imageMask.height
              ctx.drawImage(imageMask, 0, 0, canvas.width, canvas.height);
              that.adjustCanvas(canvas,that.info.brightness/50,that.info.contrast/50,that.info.saturate/50)
            };
          }else{
            const canvas = this.$refs.canvas;
            const ctx = canvas.getContext('2d');
            const image = new Image();
            image.crossOrigin = "anonymous";
            image.src = (this.info.statusNew == 'S3' ? this.getImgS3(this.info.newImage) : this.getImg(this.info.newImage))
            image.onload = () => {
              canvas.width = image.width
              canvas.height = image.height
              ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
            };
          }
        }else{
          this.$message.error(res.message)
        }
      }).catch((err) => {
        this.$message.error(err.message)
      }).finally((res) => {
        this.form_loading = false
      });
    },
    adjustCanvas(canvas, brightness, contrast, saturation) {
      const ctx = canvas.getContext('2d');
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;

      for (let i = 0; i < data.length; i += 4) {
          // RGBA格式，i表示当前像素的索引，i+1, i+2, i+3分别是红、绿、蓝和透明度值
          let r = data[i];
          let g = data[i + 1];
          let b = data[i + 2];
          let a = data[i + 3];

          // 调整亮度
          r *= brightness;
          g *= brightness;
          b *= brightness;
           // 调整对比度
          r = ((data[i] - 128) * contrast) + 128;
          g = ((data[i + 1] - 128) * contrast) + 128;
          b = ((data[i + 2] - 128) * contrast) + 128;
          // 调整饱和度
          const max = Math.max(r, g, b);
          r = max + saturation * (r - max);
          g = max + saturation * (g - max);
          b = max + saturation * (b - max);

          // 确保RGB值在0到255之间
          data[i] = r > 255 ? 255 : r < 0 ? 0 : r;
          data[i + 1] = g > 255 ? 255 : g < 0 ? 0 : g;
          data[i + 2] = b > 255 ? 255 : b < 0 ? 0 : b;
      }
      ctx.putImageData(imageData, 0, 0);
    },
    downloadImage(){
      const element = this.$refs.imgUrl;
      html2canvas(element,{useCORS:true}).then(canvas => {
        const imgData = canvas.toDataURL('image/png');
        const link = document.createElement('a');
        link.href = imgData;
        link.download = 'image.png';
        link.click();
      });
    },
    setDialogWidth() {
      var val = document.body.clientWidth
      const def = 500 // default width
      if (val < def) {
        this.dialogWidth = '100%'
      } else {
        this.dialogWidth = def + 'px'
      }
    }
  }
}
</script>

<style scoped>
  .form{display: grid;grid-template-columns:1fr 1fr;}
  .form .flex{display: flex;justify-content: space-between;min-height:60px;align-items: center;font-size: 14px;}
  .border{border-bottom: 1px solid #EDF2F7;}
  .left{border-right: 1px solid #EDF2F7;padding-right:30px;margin-right: 30px;}
  .form a{font-size: 18px;font-weight: bold;color: #5856D6;width: 100%;text-align: center;}
  >>>.el-form-item__label{line-height: 1;}
  >>>.el-dialog__header{border-bottom:1px solid #dddddd;padding:15px 20px;}
  >>>.el-dialog__body{padding:20px;}
  h1{font-size: 18px;margin:20px 0;}
  b{font-size: 18px;}
  p{font-size: 14px;}
  .label{display:flex;}
  .label span{margin:0 10px 10px 0;}
  @media (max-width: 768px) {
     .form{display: grid;grid-template-columns:1fr;}
     .left{border-right: 0px solid #EDF2F7;padding-right:0;margin-right: 0;}
  }
</style>
